import { configureStore } from '@reduxjs/toolkit';
import taskReducer from './taskSlice';
import aclReducer from './aclSlice';
import esntlReducer from './esntlSlice';

const store = configureStore({
  reducer: {
    tasks: taskReducer,
    acl: aclReducer,
    esntl: esntlReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;